import Vue from 'vue';
import VueRouter from 'vue-router';

const aanbiedingenImport = () =>
  import(/* webpackChunkName: "aanbiedingen" */ '@/views/Aanbiedingen');

const startAanbodImport = () =>
  import(/* webpackChunkName: "flow-core" */ '@/views/flow/StartAanbod');
const betaaloverzichtImport = () =>
  import(/* webpackChunkName: "flow-core" */ '@/views/flow/betaaloverzicht/Betaaloverzicht');
const overzichtImport = () =>
  import(/* webpackChunkName: "flow-core" */ '@/views/flow/overzicht/Overzicht');
const pageImport = () => import(/* webpackChunkName: "flow-core" */ '@/views/flow/page/Page.vue');
const bedankingschermImport = () =>
  import(/* webpackChunkName: "bedankingsscherm" */ '@/views/Bedankingsscherm');
const BetalingSimulatieImport = () =>
  import(/* webpackChunkName: "BetalingSimulatie" */ '@/views/BetalingSimulatie.vue');
import Oeps from '@/views/Oeps';
import Login from '@/views/Login';
import Permalink from '@/views/Permalink';

Vue.use(VueRouter);

const routes = [
  {
    path: '/nl/bedankingsscherm',
    name: 'Bedankingsscherm-nl',
    meta: {
      lang: 'nl',
      title: 'Bedankingsscherm'
    },
    component: bedankingschermImport
  },
  {
    path: '/fr/ecran-de-remerciement',
    name: 'Bedankingsscherm-fr',
    meta: {
      lang: 'fr',
      title: 'Écran de remerciement'
    },
    component: bedankingschermImport
  },
  {
    path: '/nl/:aanbod/overzicht',
    name: 'Overzicht',
    meta: {
      lang: 'nl',
      title: 'Overzicht'
    },
    component: overzichtImport
  },
  {
    path: '/fr/:aanbod/vue-d-ensemble',
    name: 'Overzicht',
    meta: {
      lang: 'fr',
      title: 'Vue d’ensemble'
    },
    component: overzichtImport
  },
  {
    path: '/nl/:aanbod/betaaloverzicht',
    name: 'Betaaloverzicht',
    meta: {
      lang: 'nl',
      title: 'Betaaloverzicht',
      updatePrijzen: true
    },
    component: betaaloverzichtImport
  },
  {
    path: '/fr/:aanbod/apercu-des-paiements',
    name: 'Betaaloverzicht',
    meta: {
      lang: 'fr',
      title: 'Aperçu des paiements'
    },
    component: betaaloverzichtImport
  },
  {
    path: '/BetalingSimulatie',
    name: 'BetalingSimulatie',
    meta: {
      title: 'Betaling simulatie'
    },
    component: BetalingSimulatieImport
  },
  {
    path: '/Login',
    name: 'Login',
    meta: { title: 'Login' },
    component: Login
  },
  {
    path: '/XeriusAccountLogin',
    name: 'XeriusAccountLogin',
    meta: { title: 'Login' },
    component: Login
  },
  {
    path: '/:lang/Oeps',
    name: 'Oeps',
    meta: { title: 'Oeps' },
    component: Oeps
  },
  {
    path: '/:lang/Permalink',
    name: 'Permalink',
    meta: { title: 'loading...' },
    component: Permalink
  },
  {
    path: '/:lang/:aanbod',
    name: 'StartAanbod',
    component: startAanbodImport
  },
  {
    path: '/:lang/:aanbod/:subflow/:page',
    name: 'Page',
    component: pageImport
  },
  {
    path: '/',
    name: 'Aanbiedingen',
    meta: { title: 'Aanbiedingen' },
    component: aanbiedingenImport
  },
  {
    path: '*',
    component: Oeps,
    meta: { title: 'Oeps' }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_PUBLIC_PATH,
  routes
});

// Route case-sensitivity hotfix
// (issue: https://github.com/vuejs/vue-router/issues/2154)
if (router.mode === 'history') {
  router.history.getCurrentLocation = function () {
    let path = window.location.pathname;
    let base = router.history.base;

    // Removes base from path (case-insensitive)
    if (base && path.toLowerCase().indexOf(base.toLowerCase()) === 0) {
      path = path.slice(base.length);
    }

    return (path || '/') + window.location.search + window.location.hash;
  };
}

router.beforeEach((to, from, next) => {
  // Sanitize query params
  if (!to.query?.aanvraagId && to.query?.AanvraagId) {
    to.query.aanvraagId = to.query.AanvraagId;
  }
  next();
});

export default router;
